import type { ReactNode } from 'react';
import p from './AppPreviews.module.css';

/**
 * Small drawings of the sample apps' first screen (apps/chores, apps/shopping, apps/hello):
 * their own header, rows and accent color, with made-up family data.
 */
export const PREVIEWS: Record<string, ReactNode> = {
  chores: (
    <div className={`${p.screen} ${p.chores}`}>
      <span className={p.h1}>Chores 🧹</span>
      <span className={p.tabs}>
        <span className={p.tabOn}>Mine</span>
        <span>Everyone</span>
        <span>This week</span>
      </span>
      <span className={p.card}>
        <Row done title="Feed the cat" meta="Maya · today 08:10" value="€1" />
        <Row title="Empty the dishwasher" meta="Maya · today" value="€2" />
        <Row title="Tidy your room" meta="Maya · on Saturday" value="€1.50" />
        <Row title="Water the plants" meta="Maya · on Sunday" value="€1" />
      </span>
    </div>
  ),
  shopping: (
    <div className={`${p.screen} ${p.shopping}`}>
      <span className={p.h1}>Shopping 🛒</span>
      <span className={p.going}>🛒 I’m going shopping</span>
      <span className={p.h2}>To get</span>
      <span className={p.card}>
        <Row title="Milk" meta="Added by Mom" value="2" />
        <Row title="Bread" meta="Added by Alex" />
      </span>
      <span className={p.h2}>In the basket</span>
      <span className={p.card}>
        <Row done title="Apples" meta="Got it: Anna" />
      </span>
    </div>
  ),
  hello: (
    <div className={`${p.screen} ${p.hello}`}>
      <span className={p.h1}>Hello, Anna</span>
      <span className={p.sub}>Family</span>
      <span className={p.h2}>Your circle</span>
      <span className={p.card}>
        <span className={p.row}>
          <span className={p.initial}>A</span>
          <span className={p.body}>
            <span className={p.title}>Alex</span>
          </span>
          <span className={p.wave}>Wave at Alex</span>
        </span>
        <span className={p.row}>
          <span className={p.initial}>M</span>
          <span className={p.body}>
            <span className={p.title}>Maya</span>
          </span>
          <span className={p.waved}>Waved ✓</span>
        </span>
      </span>
      <span className={p.h2}>Recent waves</span>
      <span className={`${p.card} ${p.feed}`}>
        <span className={p.row}>👋 Mom waved at Anna</span>
        <span className={p.row}>👋 Alex waved at Maya</span>
      </span>
    </div>
  ),
};

function Row({ title, meta, value, done }: { title: string; meta: string; value?: string; done?: boolean }) {
  return (
    <span className={done ? `${p.row} ${p.done}` : p.row}>
      <span className={p.tick}>{done ? '✓' : ''}</span>
      <span className={p.body}>
        <span className={p.title}>{title}</span>
        <span className={p.meta}>{meta}</span>
      </span>
      {value && <span className={p.value}>{value}</span>}
    </span>
  );
}
